<template>
  <div>
    <div class="check-in-page">
      <div class="qr-section">
        <div
          class="qr-btn"
          @click="toCheckOutProcess('qr-code')"
        >
          <img
            src="../../../assets/img/qr-code.png"
            alt=""
          >
          <br>
          <span> Tap to scan</span>
        </div>
      </div>
      <div class="action-area">
        <div class="action-area-section">
          <v-row>
            <v-col cols="12">
              <v-btn
                class="btn-style"
                color="#FF7E67"
                elevation="0"
                @click="toManualCheckOutProcess"
              >
                <v-icon color="black">
                  mdi-account-check-outline
                </v-icon>
                <span> Checkout </span>
              </v-btn>
            </v-col>
          </v-row>
          <!-- <div
            v-if="activeCheckInDetails.type === 'worker'"
            class="text-center"
          >
            <br />
            <span>OR</span>
            <v-btn
              class="btn-style"
              color="#FFCA68"
              elevation="0"
              @click="toCostShiftProcess()"
              :disabled="isCheckedInFromKiosk"
            >
              <v-icon color="black"> mdi-currency-usd </v-icon>
              <span> Cost Shift </span>
            </v-btn>
          </div> -->
          <check-out-page-history />
        </div>
      </div>
    </div>
    <qr-code-scanner
      v-if="showQrCodeScanner"
      @closed="showQrCodeScanner = false"
      @qr-code-scanned="toSelectedCheckOutProcessByQRScan"
    />
    <manual-check-out
      v-if="showManualCheckOut"
      @closed="showManualCheckOut = false"
      @off-site-selected="addOffSiteDetails"
      @on-site-selected="selectProjectGate"
    />
    <select-project-gate
      v-if="showProjectGates"
      @closed="showProjectGates = false"
      @project-gate-selected="toCheckOutProcessByManualOnSite"
    />
    <center-spinner :loading="loading" />
    <manual-check-out-off-site
      v-if="showManualCheckOutOffSite"
      @manual-offsite-confirmed="toCheckOutProcessByManualOffSite"
      @closed="showManualCheckOutOffSite = false"
    />
    <worker-cost-shift
      v-if="showCostShift"
      :active-check-in-details="activeCheckInDetails"
      @closed="showCostShift = false"
    />
    <alert-dialog
      v-if="showAlert"
      :title="'⚠️ Check-out Too Early ?'"
      :message="'You have logged less than 15 minutes. If you proceed, the timesheet will be deleted as its considered invalid. Do you want to continue with check-out?'"
      @closed="showAlert = false"
      @confirmed="checkoutConfirmed()"
    />
    <check-out-sheet
      v-if="openCheckOutSheet"
      :location-enable-check="locationEnableCheck"
      @closed="openCheckOutSheet = false"
    />
    <check-out-sheet-qr
      v-if="openCheckOutQrSheet"
      :gate="gateId"
      :location-enable-check="locationEnableCheck"
      @closed="openCheckOutQrSheet = false"
    />
  </div>
</template>

<script>
import QrCodeScanner from '../../process/QrCodeScanner.vue';
import spinner from '../../components/SpinnerCentre.vue';
import ManualCheckout from '../Components/dialogComponents/ManualCheckOut.vue';
import SelectProjectGate from 'src/views/dashboard/Components/dialogComponents/SelectProjectGate';
import ManualCheckOutOffSite from 'src/views/dashboard/Components/dialogComponents/ManualCheckOutOffSite';
import WorkerCostShiftPage from './CostShift/WorkerCostShiftPage.vue';
import CheckOutSheet from './CheckOutSheet.vue';
import CheckOutPageHistory from '../Components/CheckOutPageHistory.vue';
import Constants from 'src/constants';
import AlertDialog from 'src/views/components/AlertDialog.vue';
import CheckOutSheetQr from './CheckOutSheetQr.vue';

export default {
  name: 'CheckOutPage',
  components: {
    'qr-code-scanner': QrCodeScanner,
    'center-spinner': spinner,
    'manual-check-out': ManualCheckout,
    'select-project-gate': SelectProjectGate,
    'manual-check-out-off-site': ManualCheckOutOffSite,
    'worker-cost-shift': WorkerCostShiftPage,
    'check-out-sheet': CheckOutSheet,
    'check-out-page-history': CheckOutPageHistory,
    'alert-dialog': AlertDialog,
    'check-out-sheet-qr': CheckOutSheetQr,
  },
  data: () => ({
    loading: false,
    showQrCodeScanner: false,
    showManualCheckOut: false,
    showProjectGates: false,
    showManualCheckOutOffSite: false,
    checkOutMethodType: null,
    showCostShift: false,
    hours: null,
    minutes: null,
    showAlert: false,
    checkoutType: '',
    openCheckOutSheet: false,
    openCheckOutQrSheet: false,
    gateId: null,
  }),
  computed: {
    activeCheckInDetails () {
      return this.$store.getters['swiftuser/getActiveCheckInDetails'];
    },
    selectedOrgProjectGate () {
      return this.$store.getters['projects/getSelectedOrgProjectGate'];
    },
    isCheckedInFromKiosk () {
      if (
        Object.keys(this.activeCheckInDetails).length > 0 &&
        this.activeCheckInDetails.checkin_kiosk !== null
      ) {
        return true;
      }
      return false;
    },
    isActiveCheckInDetailsFetched () {
      if (Object.keys(this.activeCheckInDetails).length > 0) {
        return true;
      }
      return false;
    },
    workTimerLastUpdatedAt () {
      return this.$store.getters['devices/getWorkTimerUpdatedAt'];
    },
    userData () {
      return this.$store.getters.getSelectedOrganization;
    },
    orgSettings () {
      return this.$store.getters['organization/getOrganizationSettings'];
    },
    locationEnableCheck () {
      return this.orgSettings.location_verification;
    },
  },
  watch: {
    workTimerLastUpdatedAt (val) {
      this.setClock();
    },
  },
  async mounted () {
    this.loading = true;
    await this.setClock();
    await this.fetchOrgDetails();
    await this.fetchActiveCheckinDetails();
    await this.loadOnMount();
    await this.checkQrScanTime();
    this.loading = false;
  },
  methods: {
    async fetchActiveCheckinDetails () {
      await this.$store.dispatch('swiftuser/fetchUsersCurrentCheckInDetails');
    },
    checkQrScanTime () {
      const scannedTime = localStorage.getItem('scannedTime');
      if (scannedTime === null) {
        return;
      }
      const currentTime = new Date().getTime();
      if (currentTime - scannedTime >= 300000) {
        localStorage.removeItem('siteId');
        localStorage.removeItem('scannedTime');
      }
    },
    loadOnMount () {
      if (this.isActiveCheckInDetailsFetched === true) {
        return;
      }
      this.$router.push({ name: 'HomePage' });
    },
    openQrCodeScanner () {
      this.loading = true;
      this.checkQrScanTime();
      setTimeout(() => {
        this.showQrCodeScanner = true;
        this.loading = false;
      }, 1000);
    },
    async fetchOrgDetails () {
      await this.$store.dispatch(
        'organization/fetchOrganizationSettings',
        this.userData,
      );
    },
    toCheckOutProcess (type) {
      var breakTime = localStorage.getItem('breakTime');
      if (breakTime !== null) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please remove the break before check-out!',
          type: Constants.ALERT_TYPE_INFO,
        });
        return;
      }
      if (this.userData.timesheet_tracking) {
        if (Number(this.hours) === 0) {
          if (Number(this.minutes) >= 15) {
            this.loading = true;
            this.checkOutMethodType = type;
            if (this.checkOutMethodType === 'manual') {
              this.loading = false;
              this.showManualCheckOut = true;
            } else {
              this.checkQrScanTime();
              const siteId = localStorage.getItem('siteId');
              if (siteId !== null) {
                this.toSelectedCheckOutProcessByQRScan(siteId);
                this.loading = false;
                return;
              }
              this.loading = false;
              this.showQrCodeScanner = true;
            }
          } else {
            this.showAlert = true;
            this.checkoutType = type;
          }
        } else {
          this.loading = true;
          this.checkOutMethodType = type;
          if (this.checkOutMethodType === 'manual') {
            this.loading = false;
            this.showManualCheckOut = true;
          } else {
            this.checkQrScanTime();
            const siteId = localStorage.getItem('siteId');
            if (siteId !== null) {
              this.toSelectedCheckOutProcessByQRScan(siteId);
              this.loading = false;
              return;
            }
            this.loading = false;
            this.showQrCodeScanner = true;
          }
        }
      } else {
        this.openCheckOutSheet = true;
      }
    },
    toManualCheckOutProcess () {
      var breakTime = localStorage.getItem('breakTime');
      if (breakTime !== null) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please remove the break before check-out!',
          type: Constants.ALERT_TYPE_INFO,
        });
        return;
      }
      if (this.userData.timesheet_tracking) {
        if (Number(this.hours) === 0) {
          if (Number(this.minutes) >= 15) {
            this.openCheckOutSheet = true;
          } else {
            this.showAlert = true;
            this.checkoutType = 'manual';
          }
        } else {
          this.openCheckOutSheet = true;
        }
      } else {
        this.openCheckOutSheet = true;
      }
    },
    checkoutConfirmed () {
      this.loading = true;
      this.checkOutMethodType = this.checkoutType;
      if (this.checkOutMethodType === 'manual') {
        this.loading = false;
        this.showAlert = false;
        this.checkoutType = '';
        this.openCheckOutSheet = true;
      } else {
        this.checkQrScanTime();
        const siteId = localStorage.getItem('siteId');
        if (siteId !== null) {
          this.toSelectedCheckOutProcessByQRScan(siteId);
          this.loading = false;
          this.showAlert = false;
          this.checkoutType = '';
          return;
        }
        this.loading = false;
        this.showAlert = false;
        this.checkoutType = '';
        this.showQrCodeScanner = true;
      }
    },
    toCostShiftProcess () {
      this.showCostShift = true;
      // const siteId = this.activeCheckInDetails.project.id;
      // this.$router.push(`cost-shift/${siteId}/worker`);
    },
    toSelectedCheckOutProcessByQRScan (id) {
      this.showQrCodeScanner = false;
      this.$store.dispatch('swiftuser/storeCheckOutMethodType', {
        type: 'qrScan',
      });
      this.gateId = id;
      this.openCheckOutQrSheet = true;
      // const type = this.activeCheckInDetails.type;
      // const siteId = id;
      // this.$router.push(`check-out/${siteId}/${type}`);
    },
    addOffSiteDetails () {
      this.showManualCheckOut = false;
      this.showManualCheckOutOffSite = true;
    },
    selectProjectGate () {
      this.$store.dispatch(
        'projects/selectedOrgProject',
        this.activeCheckInDetails.project,
      );
      this.showManualCheckOut = false;
      this.showProjectGates = true;
    },
    toCheckOutProcessByManualOnSite () {
      this.showManualCheckOut = false;
      this.showProjectGates = false;
      this.$store.dispatch('swiftuser/storeCheckOutMethodType', {
        type: 'manual-onsite',
      });
      const type = this.activeCheckInDetails.type;
      const siteId = this.selectedOrgProjectGate.id;
      this.$router.push(`check-out/${siteId}/${type}`);
    },
    toCheckOutProcessByManualOffSite () {
      this.showManualCheckOut = false;
      this.showProjectGates = false;
      this.$store.dispatch('swiftuser/storeCheckOutMethodType', {
        type: 'manual-offsite',
      });
      this.showManualCheckOutOffSite = false;
      const type = this.activeCheckInDetails.type;
      const siteId =
        this.activeCheckInDetails.checkin_gate !== null
          ? this.activeCheckInDetails.checkin_gate.id
          : null;
      this.$router.push(
        `check-out/${
          siteId !== null ? siteId : 'manual-offsite-checkout'
        }/${type}`,
      );
    },
    setClock () {
      var checkInTime = localStorage.getItem('checkInTime');
      if (checkInTime === null) {
        this.hours = null;
        this.minutes = null;
        return;
      }
      this.StartClock();
    },
    StartClock () {
      var checkInTime = localStorage.getItem('checkInTime');
      if (checkInTime === null) {
        this.hours = null;
        this.minutes = null;
        return;
      }
      var parsedCheckInTime = JSON.parse(checkInTime);
      var updatedTime = +new Date();
      this.difference = updatedTime - parsedCheckInTime;
      var minutes = Math.floor(
        (this.difference % (1000 * 60 * 60)) / (1000 * 60),
      );
      var hours = Math.floor(
        (this.difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      this.hours = hours < 10 ? '0' + hours : hours;
      this.minutes = minutes < 10 ? '0' + minutes : minutes;
    },
  },
};
</script>
<style scoped>
.cost-shift-btn {
  background: #fff !important;
  color: #000;
  height: 36px !important;
  width: 100% !important;
  box-shadow: none;
  border: 1px solid #000;
  padding: 24px;
  border-radius: 50px;
}
.or {
  color: #5f5f5f;
}
.v-btn.theme--dark.v-btn--disabled.v-btn--has-bg {
  background: rgb(202, 202, 202) !important;
  border: none;
}
.v-btn.theme--dark.v-btn--disabled.v-btn--has-bg span {
  color: white;
}
.check-in-page {
  position: relative;
  height: 100vh;
}

.qr-section {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  height: 50%;
  width: 100%;
}

.action-area {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 50%;
  background: #F5F5FF;
  overflow-y: scroll;
}

.action-area-section {
  padding: 20px 20px 20px 20px;
}

.qr-btn {
  height: auto !important;
  text-align: center;
}
</style>
